import type MP4Box from 'mp4box';
import { MAX_DURATION_SEC } from '../../constants';
import type { AddError } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';

const validateDuration = (info: MP4Box.Mp4BoxInfo, addError: AddError): void => {
  const [videoTrack] = info.videoTracks;
  const seconds = videoTrack.duration / videoTrack.timescale;
  if (seconds > MAX_DURATION_SEC) {
    addError(VALIDATIONS.MAX_DURATION);
  }
};

export default validateDuration;
